export function linkFormat(url) {
  if (!url) {
    return "";
  }
  if (
    url.includes("thermacell.com") &&
    !url.startsWith("https://info") &&
    !url.startsWith("https://blog") &&
    !url.startsWith("https://checkout")
  ) {
    //eslint-disable-next-line
    return url.replace(/https?:\/\/[^\/]+/i, "");
  }

  return url;
}
